import { Dialog, DialogContent } from '@components/shared/dialog'
import { Button } from '@components/ui/button'
import { paths } from '@router/paths'
import { FC } from 'react'

interface BannedUserModalProps {
  onClose: () => void
}

export const BannedUserModal: FC<BannedUserModalProps> = ({ onClose }) => {
  const onBackClick = () => {
    onClose()

    // native redirect using window.location
    window.location.href = paths.root
  }

  const onEmailUsClick = () => {
    const recipient = 'hello@common-wealth.io'
    const mailtoLink = `mailto:${recipient}`
    window.location.href = mailtoLink
  }

  return (
    <Dialog open>
      <DialogContent className="xs:w-[45rem] max-w-[95%]" isClosable={false}>
        <div className="flex flex-col items-center justify-center pt-5 text-center">
          <img
            src={'/images/errors/basic-error.svg'}
            alt={'wrong-network-error'}
            className="scale-75 xs:scale-100"
          />
          <p className="mt-10 text-h3 xs:text-h2">Your account has been blocked</p>

          <p className="mt-2 text-body1 text-cw-light-grey xs:mt-4">
            Your account has been blocked due to breach of the terms and conditions. If
            you think this is in error - please visit{' '}
            <a className="text-cw-yellow underline" href="/docs/support" target="_blank">
              /docs/support
            </a>{' '}
            or email us at
            <br />
            <a href="mailto:hello@common-wealth.io" className="text-cw-yellow underline">
              hello@common-wealth.io
            </a>
          </p>

          <div className="mt-10 flex w-full flex-col-reverse justify-center gap-5 xs:mx-auto xs:mt-16 xs:max-w-lg xs:flex-row xs:items-center">
            <Button variant="secondary" className="flex-1" onClick={onBackClick}>
              Back
            </Button>

            <Button className="flex-1" onClick={onEmailUsClick}>
              Email Us
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
